import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center my-5">
            <h1>404 Page Not Found</h1>
            <h3>The page you are looking is unavailable</h3>
        </div>
    );
};

export default NotFound;